import { useWindowSize } from "usehooks-ts"

export const useIsMobile = (windowWidth = 660) => {
  const windowSize = useWindowSize()

  return windowSize?.width <= windowWidth
}
